
<template>
  <div class="PacienteDetalleAntecedentes">
    <v-card-title v-text="'Antecedentes'" />
    <v-card-subtitle v-text="'Información de antecedentes médicos'" />
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="6"
        lg="4"
      >
        <PacientesAntecedentesAlergias
          class="mb24"
          :paciente="idPac"
          readonly
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="6"
        lg="4"
      >
        <PacientesAntecedentesHeredofamiliares
          class="mb24"
          :paciente="idPac"
          readonly
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="4"
      >
        <PacientesAntecedentesNoPatologicos
          class="mb24"
          :paciente="idPac"
          readonly
        />
      </v-col>
      <v-col cols="12">
        <PacientesAntecedentesPatologicos
          class="mb24"
          :paciente="idPac"
          readonly
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import PacientesAntecedentesAlergias from "@/components/pacientes/antecedentes/PacientesAntecedentesAlergias.vue";
import PacientesAntecedentesHeredofamiliares from "@/components/pacientes/antecedentes/PacientesAntecedentesHeredofamiliares.vue";
import PacientesAntecedentesNoPatologicos from "@/components/pacientes/antecedentes/PacientesAntecedentesNoPatologicos.vue";
import PacientesAntecedentesPatologicos from "@/components/pacientes/antecedentes/PacientesAntecedentesPatologicos.vue";
export default {
  name: "PacienteDetalleAntecedentes",
  components: {
    PacientesAntecedentesAlergias,
    PacientesAntecedentesHeredofamiliares,
    PacientesAntecedentesNoPatologicos,
    PacientesAntecedentesPatologicos,
  },
  props: {
    id: [String, Number],
  },
  data() {
    return {
      idPac: null,
    };
  },
  methods: {
    _handleIdPac() {
      this.idPac = this.id;
    },
  },
  created() {
    this._handleIdPac();
  },
  watch: {
    id() {
      this._handleIdPac();
    },
  },
};
</script>

